export default __webpack_public_path__ + "static/media/Chelsea_Stevenson_AHV_In_Moms_We_Trust.d0fed521.jpg";